import { api } from 'shared/api';

const _api = api.injectEndpoints({
  endpoints: (build) => ({
    reportBug: build.mutation({
      query: (body: FormData) => ({
        url: '/user/report-problem',
        method: 'POST',
        body,
        formData: true
      })
    })
  })
})

export const { useReportBugMutation } = _api; 